import React from "react";

const features = [
  {
    icon: "fa-users",
    number: "01",
    title: "AI-Driven Job & Candidate Management",
    description: "Store and organize job requirements and candidate profiles in one place.",
  },
  {
    icon: "fa-lightbulb",
    number: "02",
    title: "Resume Parsing & Skill Matching",
    description: "AI extracts key details from multiple resumes and compares them with job descriptions.",
  },
  {
    icon: "fa-video",
    number: "03",
    title: "AI-Powered Video & Coding Tests",
    description: "Conduct AI-driven video interviews and coding tests with screen recording.",
  },
  {
    icon: "fa-question-circle",
    number: "04",
    title: "Client & Submission Management",
    description: "Centralized dashboard to manage client details and track candidate submissions.",
  },
];

const WorkProcess = () => {
  return (
    <div className="work-process-area overflow-hidden bottom-less">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h2>Core Features</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="work-pro-items">
          <div className="row">
            {features.map((feature, index) => (
              <div className="single-item col-lg-3 col-md-6" key={index}>
                <div className="item">
                  <div className="item-inner">
                    <div className="icon">
                      <i className={`fa ${feature.icon}`} style={{fontSize: 60,
color:"#00a7ac",
marginBottom: 30}}></i>
                      <span>{feature.number}</span>
                    </div>
                    <h5>{feature.title}</h5>
                    <p>{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <style jsx>
          {`.site-heading h2 {
    display: inline-block;
    font-weight: 600;
    padding-bottom: 20px;
    margin-bottom: 0;
    position: relative;
    letter-spacing: 1px;
    line-height: 1.4;
    margin-top: 40px;
}
.site-heading h2::before {
    background: #086AD8 none repeat scroll 0 0;
    bottom: 0;
    content: "";
    height: 2px;
    left: 50%;
    margin-left: -25px;
    position: absolute;
    width: 60px;
}
.work-process-area .work-pro-items .item i {
    display: inline-block;
    color: #086AD8;
    font-size: 60px;
    margin-bottom: 30px;
}
.flaticon-select:before {
    content: "\f111";
}
.work-process-area .work-pro-items .item .item-inner::after {
    / right: 0; /
    bottom: 0;
}
.work-process-area .work-pro-items .item {
    border: 1px solid #e7e7e7;
    padding: 50px 30px;
    background: #ffffff;
    position: relative;
    z-index: 1;
    overflow: hidden;
}
.work-process-area .work-pro-items .item::before, .work-process-area .work-pro-items .item::after {
    content: "";
    width: 0;
    height: 2px;
    position: absolute;
    transition: all 0.2s linear;
    background: #086AD8;
}
.work-process-area .work-pro-items .item .item-inner::before {
    left: 0;
    top: 0;
}
.work-process-area .work-pro-items .item .icon {
    position: relative;
}
.work-process-area .work-pro-items .item h5 {
    position: relative;
    z-index: 1;
    font-weight: 600;
    font-size: 18px;
}
.work-process-area .work-pro-items .item p {
    margin: 0;
}
.work-process-area .work-pro-items .item::after {
    left: 0;
    bottom: 0;
}
.work-process-area .work-pro-items .item i {
    display: inline-block;
    color: #00a7ac;
    font-size: 60px;
    margin-bottom: 30px;
}
.work-process-area .work-pro-items .item .icon {
    position: relative;
}
.work-process-area .work-pro-items .item .icon span {
    position: absolute;
    left: 15px;
    top: 0;
    font-size: 100px;
    z-index: -1;
    color: #f4f4f4;
    opacity: 0.9;
    font-weight: 900;
    color: transparent;
    -webkit-text-stroke: 2px #f4f4f4;
    line-height: 50px;
    font-family: sans-serif;
}
.site-heading h2::after {
    background: #ffffff  none repeat scroll 0 0 !important;
    bottom: 0;
    content: "";
    height: 2px;
    left: 50%;
    margin-left: 20px;
    position: absolute;
    width: 5px;
}
.work-process-area .single-item {
    margin-bottom: 30px;
}
.work-process-area .work-pro-items .item {
    border: 1px solid #e7e7e7;
    padding: 50px 30px;
    background: #ffffff;
    position: relative;
    z-index: 1;
    overflow: hidden;
    height: 290px;
}
.work-process-area .work-pro-items .item::before {
    right: 0;
    top: 0;
}
.work-process-area .work-pro-items .item::before, .work-process-area .work-pro-items .item::after {
    content: "";
    width: 0;
    height: 2px;
    position: absolute;
    transition: all 0.2s linear;
    background: #086AD8;
} `}
        </style>
      </div>
    </div>
  );
};

export default WorkProcess;
